'use client';


import { createProvider } from '../../utils/zustand';

import type { IsMobileProviderState } from '../view-models/is-mobile-provider-state';
import type { PropsWithChildren } from 'react';

export const useIsMobileProvider = createProvider<IsMobileProviderState>(() => () => ({
  isMobile: false
}));

interface IsMobileProviderProps {
  isMobile?: boolean;
}

export function IsMobileProvider(props: PropsWithChildren<IsMobileProviderProps>) {
  const isMobile = !!props.isMobile;

  return (
    <useIsMobileProvider.State initialState={{ isMobile }}>
      {props.children}
    </useIsMobileProvider.State>
  );
}
